const onLineView = () => import('@/page/class')
const onLineList = () => import('@/page/class/class-list')
const onLineDetail = () => import('@/page/class/class-detail')
const courseDetail = () => import('@/page/course/course-detail')
const classResourse = () => import('@/page/class/class-menu/resourse')
const onLineCertificate = () => import('@/page/class/class-menu/certificate')
const classAlbum = () => import('@/page/class/class-menu/album')

export default [
  {
    path: '/onLine',
    name: 'onLine',
    component: onLineView,
    children: [
      {
        path: 'onLine-list',
        name: 'onLine-list',
        component: onLineList
      },
      {
        path: 'onLine-detail',
        name: 'onLine-detail',
        component: onLineDetail
      },
      {
        path: 'course-detail',
        name: 'course-detail',
        component: courseDetail
      },
      {
        path: 'onLine-certificate',
        name: 'onLine-certificate',
        component: onLineCertificate
      },
      {
        path: 'class-resourse',
        name: 'class-resourse',
        component: classResourse
      },
      {
        path: 'class-album',
        name: 'class-album',
        component: classAlbum
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/on-line/index.js